export enum WhosWhoStatusEnum {
  TBA = 0,
  CanCall = 1,
  DoNotCall = 2,
}
